import { NgClass } from "@angular/common";
import {
  AfterViewInit,
  Component,
  OnDestroy,
  signal,
  Input,
  ChangeDetectionStrategy,
} from "@angular/core";
import { RouterLink } from "@angular/router";

@Component({
  selector: "claas-scroll-to-top",
  imports: [NgClass, RouterLink],
  templateUrl: "./scroll-to-top.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./scroll-to-top.scss",
})
export class ScrollToTop implements AfterViewInit, OnDestroy {
  showScrollTop = signal(false);
  scrollPosition = signal(0);
  private scrollContainer?: HTMLElement | null;

  @Input()
  ngClass: string[] = [];

  private scrollHandler = () => {
    if (!this.scrollContainer) return;
    this.scrollPosition.update(
      (position) => (position += this.scrollContainer?.scrollTop ?? 0),
    );
    this.showScrollTop.set(this.scrollContainer.scrollTop > 200);
  };

  ngAfterViewInit() {
    this.scrollContainer = document.querySelector(
      "mat-sidenav-content",
    ) as HTMLElement | null;
    if (this.scrollContainer) {
      this.scrollContainer.addEventListener("scroll", this.scrollHandler);
    } else {
      console.warn("Could not find mat-sidenav-content");
    }
  }

  ngOnDestroy() {
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener("scroll", this.scrollHandler);
    }
  }
}
